import { selectTypeOfUpdate, setTypeOfUpdate, UpdateClientType } from '../../../../features/client/clientSlice';
import { useDispatch, useSelector } from 'react-redux';

interface ClientUpdateBtnWrapProps {
    updateType: UpdateClientType;
    onSave: () => void;
    onCancel: () => void;
    isLoading: boolean; 
}

export default function ClientUpdateBtnWrap({ updateType, onSave, onCancel, isLoading }: ClientUpdateBtnWrapProps) {
    
    const dispatch = useDispatch()
    const typeOfUpdate = useSelector(selectTypeOfUpdate)
    const isEditing = typeOfUpdate === updateType;
    const updateLabel = updateType
        ?.replace(/^up/, "")
        .replace(/([A-Z])/g, " $1")
        .trim()
        .toLowerCase();

    return (
        <div className='col-span-2'>
            <div className={`grid ${isLoading ? 'grid-cols-1' : isEditing ? 'grid-cols-2' : ''} gap-2`}>
                {isEditing ? (
                    isLoading ? (
                        <button type="button" disabled className="w-full text-sm px-4 py-2 rounded font-medium bg-gray-400 text-white cursor-not-allowed">
                            Updating...
                        </button>
                    ) : (
                        <>
                            <button
                                onClick={onCancel}
                                type="button"
                                className="w-full text-sm px-4 py-2 rounded font-medium bg-gray-300 text-black"
                            >
                                {'Cancel'}
                            </button>
                            <button
                                onClick={onSave}
                                type="button"
                                className="w-full text-sm px-4 py-2 rounded font-medium bg-cbColor text-white"
                            >
                                {'Save'}
                            </button>
                        </>
                    )
                ) : (
                    <button 
                        onClick={() => dispatch(setTypeOfUpdate(updateType))}
                        type="button" 
                        className="col-span-1 w-full text-sm px-4 py-2 rounded font-medium bg-cbColor text-white cursor-pointer">
                        {`Update ${updateLabel}`}
                    </button>
                )}
                
            </div>
        </div>
    )
}
